import { gql } from '@apollo/client';

export const updateFeedbackQuery = gql`
  mutation editFeedback($input: InputCreateFeedback!, $feedbackId: String!) {
    editFeedback(input: $input, feedbackId: $feedbackId)
  }
`;
